
var    omadapp = omadapp ||{interfaces:{},components:{},singletons:{},model:{},controllers:{scenes:{}}}
omadapp.modoDebug = window.location.href.indexOf("debug")>-1
function trace(str,lvl) {
	if (!omadapp.modoDebug) return;
	lvl = lvl||0
    if (console.log&&lvl>=0) {
        console.log(str);
    }
}
function trace_l(str) {
	if (!omadapp.modoDebug) return;
	
    if (console.trace) {
        console.trace(str);
    }
}

